export const moderateFund = {
    code: 'FNBMF',
    expectedReturn: 0.085,
    term: 5,
    scenarios: {
        5: { down: 0.00748583885872637, expected: 0.0121640964816353, up: 0.0149118231004672 },
        6: { down: 0.00978682857424966, expected: 0.0114131520067135, up: 0.0145693056707585 },
    },
};
